import { render, staticRenderFns } from "./summary-table.vue?vue&type=template&id=73f2000e&scoped=true"
import script from "./summary-table.vue?vue&type=script&lang=js"
export * from "./summary-table.vue?vue&type=script&lang=js"
import style0 from "./summary-table.vue?vue&type=style&index=0&id=73f2000e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f2000e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f2000e')) {
      api.createRecord('73f2000e', component.options)
    } else {
      api.reload('73f2000e', component.options)
    }
    module.hot.accept("./summary-table.vue?vue&type=template&id=73f2000e&scoped=true", function () {
      api.rerender('73f2000e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/summary-table.vue"
export default component.exports